"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

var _ui = require("@probeton/ui");

var _pocUi = require("@solar/poc-ui");

var _UnitInfo = _interopRequireDefault(require("./UnitInfo"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var UnitSheet = function UnitSheet(_ref) {
  var unit = _ref.unit,
      history = _ref.history,
      loading = _ref.loading,
      handleUnitClick = _ref.handleUnitClick,
      handleUserClick = _ref.handleUserClick,
      handleOnboarding = _ref.handleOnboarding,
      action = _ref.action,
      labels = _ref.labels;
  var key = unit.key,
      name = unit.name,
      cover = unit.cover,
      location = unit.location;
  var tabs = {
    info: {
      label: labels.tabs.info,
      component: /*#__PURE__*/_react["default"].createElement(_UnitInfo["default"], {
        unit: unit,
        onUserClick: handleUserClick,
        onUnitClick: handleUnitClick,
        onStartOnboarding: handleOnboarding,
        loading: loading,
        labels: _objectSpread(_objectSpread({}, labels.info), {}, {
          actions: labels.actions,
          status: labels.status
        })
      })
    },
    certificates: {
      label: labels.tabs.certificates,
      component: /*#__PURE__*/_react["default"].createElement(_ui.CertificateList, {
        certificates: (unit.certificates || []).slice().sort(function (a, b) {
          return a.key < b.key ? -1 : 1;
        }),
        manufacturer: unit.manufacturer,
        unit: unit,
        openCertificate: function openCertificate(certificateId) {
          return history.push("/certificates/".concat(certificateId));
        },
        hideOwner: true,
        labels: labels
      })
    }
  };
  return /*#__PURE__*/_react["default"].createElement(_pocUi.CoverTabView, {
    title: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_core.Typography, {
      variant: "h4",
      color: "inherit"
    }, key, ". ", name), /*#__PURE__*/_react["default"].createElement(_core.Typography, {
      variant: "h6",
      color: "inherit"
    }, location.formatted_address)),
    tabs: tabs,
    action: action,
    cover: cover && cover.src
  });
};

var _default = UnitSheet;
exports["default"] = _default;